import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CategoriesTranslations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CategoriesTranslations'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: '',
      description: '',
      localeId: null,
      standardActionId: null,
    }
  }
}
const servicePath = 'categories-translations'
const servicePlugin = makeServicePlugin({
  Model: CategoriesTranslations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
